export default "__VITE_ASSET__Cmxe2iMb__"